/* global breakpointMd, windowWidth, attachEvent, slideUp, slideDown */

// **********************************************************
// Main menu dropdown
// **********************************************************

const menuElem = document.querySelectorAll('.has-submenu');

attachEvent('[data-megamenu-trigger]', 'click', (ev) => {
  const arrowParent = ev.target.closest('.menu__item');
  const menuDropdown = arrowParent.querySelectorAll('.mega-menu')[0];

  if (windowWidth() < breakpointMd) {
    if (arrowParent.classList.contains('is-open-submenu')) {
      slideUp(menuDropdown, 300);
      arrowParent.classList.remove('is-open-submenu');
    } else {
      arrowParent.classList.add('is-open-submenu');
      slideDown(menuDropdown, 300);
    }
  } else {
    menuElem.forEach((elem) => {
      if (elem === arrowParent) {
        arrowParent.classList.toggle('is-megamenu-open');
      } else {
        elem.classList.remove('is-megamenu-open');
      }
    });
  }

  ev.preventDefault();
});

document.addEventListener('click', (evt) => {
  const megaOpenLink = document.querySelector('.has-submenu.is-megamenu-open');
  let targetElement = evt.target;

  do {
    if (targetElement === megaOpenLink) {
      return;
    }
    targetElement = targetElement.parentNode;
  } while (targetElement);

  menuElem.forEach((el) => {
    const menuLinkParent = el.closest('.menu__item');
    menuLinkParent.classList.remove('is-megamenu-open');
  });
});
